import { SxProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import React, { MouseEventHandler } from 'react';

interface Props {
  color: string;
  hoverColor?: string;
  icon: React.ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps;
  tooltip?: string;
}

export const IconButtonWithColors: React.FC<Props> = props => {
  const { color, hoverColor, icon, onClick, sx, tooltip } = props;

  const handleClick: MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    onClick?.(event);
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton
        onClick={handleClick}
        sx={{
          '&:hover': {
            color: hoverColor,
          },
          color,
          ...sx,
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};
